<template>
  <div class="container-body">
    <div class="container-main">
      <WorkRegistrationForm :workDate = "workDate" :drivers = "drivers"/>
    </div>
  </div>
</template>
<script>
import WorkRegistrationForm from "../components/WorkRegistrationForm";

export default {
  name: "CreateWorkRegistration",
  components: {
    WorkRegistrationForm,
  },
  data() {
    return {
      drivers: null,
      workDate: null,
    };
  },
  created() {
    this.workDate = this.$route.query.workDate;
    this.drivers = this.$route.query.workDay.drivers;
  },
};
</script>
